interface Props {
  isRequired?: boolean;
}

export default function ({ isRequired = false }: Props) {
  return (
    <span aria-hidden="true" className="align-super text-red-500">
      {isRequired ? '*' : ' '}
    </span>
  );
}
